<emoji-mart
  class="step-form__form__item__picker__emoji"
  size="20"
  [i18n]="emojiPickerI18n"
  [title]="'ADMIN_LEARNING_MODULES.EMOJI_LABEL' | translate"
  [isNative]="true"
  [showPreview]="false"
  (emojiSelect)="emojiSelect($event)"
></emoji-mart>
